import { ReactiveController, ReactiveControllerHost } from "lit";
import { Toast } from "../models";

/**
 * Controller for managing toast notifications.
 */
export class ToastController implements ReactiveController {
  private _toasts: Toast[] = [];
  private _nextId = 0;

  constructor(private host: ReactiveControllerHost) {
    host.addController(this);
  }

  hostConnected() {}
  hostDisconnected() {}

  get toasts() {
    return this._toasts;
  }

  show(message: string, type: Toast["type"] = "success") {
    const id = this._nextId++;
    const toast: Toast = { id, message, type };
    this._toasts = [...this._toasts, toast];
    this.host.requestUpdate();

    setTimeout(() => {
      this._toasts = this._toasts.filter((t) => t.id !== id);
      this.host.requestUpdate();
    }, 3000);
  }
}
